import { CalculationRowType, TotalWorkerPaymentUsecase, TotalWorkerPaymentKind, UserDefinedRow } from "../../model";
import { EnumerationsLogic, Translations } from "../../logic";
import { Numeric } from "../../util";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for TotalWorkerPayment  */
export class TotalWorkerPaymentUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  public updateUsecase(row: UserDefinedRow): void {
    const data: TotalWorkerPaymentUsecase = row.data || {};

    if (!data.kind || data.kind === TotalWorkerPaymentKind.Undefined) {
      data.kind = TotalWorkerPaymentKind.TotalWorkerPayment;
    }

    if (!data.rowType) {
      data.rowType = CalculationRowType.Salary;
    }

  }

  /** Gets validation message for BoardUsecaseLogic  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: TotalWorkerPaymentUsecase = row.data || {};

    if (!data.kind || data.kind === TotalWorkerPaymentKind.Undefined) {
      data.kind = TotalWorkerPaymentKind.TotalWorkerPayment;
    }

    if (!data.rowType) {
      data.rowType = CalculationRowType.Salary;
    }

    return {
      type: "default",
      msg: `${EnumerationsLogic.getEnumLabel("CalculationRowType", data.rowType)} ${Translations.get("SALAXY.VALIDATION.Usecases.totalWorkerPayment.default")} ${Numeric.formatPrice(row.price)} ${Translations.get("SALAXY.VALIDATION.Usecases.totalWorkerPayment.default2")} ${EnumerationsLogic.getEnumLabel("TotalWorkerPaymentKind", data.kind)}.`,
    };
  }
}
